// Splide init
// function mmInitSplide() {
//     const id = ".splide-mm-cart";
//     const splideElem = document.querySelector(id);

//     if (splideElem) {
//         new Splide(splideElem, {
//           type: "slide",
//           arrows: false,
//           pagination: false,
//           rewind: false,
//           destroy: false,
//           gap: 27,
//           perPage: 1,
//           autoHeight: true,
//           drag: "free",
//           width: 217,
//           height: "100%",
//           direction: "ttb",
//           breakpoints: {
//             768: {
//               destroy: true,
//             },
//           },
//         }).mount();
//     }
// }

function mmInitSplideMobile() {
  const idMobile = ".mm-splide-crossell";
  const splideElemMobile = document.querySelector(idMobile);

  if (splideElemMobile) {
    let splide = new Splide(splideElemMobile, {
      type: "slide",
      arrows: false,
      pagination: false,
      rewind: false,
      gap: "12px",
      perPage: 1,
      autoWidth: true,
      padding: {
        left: "24px",
        right: "24px",
      },
      breakpoints: {
        768: {
          padding: {
            left: "12px",
            right: "12px",
          },
        },
      },
    }).mount();

    let splideContainer = splideElemMobile.closest(".mm-dc-cross-sell");

    let arrowNext = splideContainer.querySelector(".mm-arrow-right");
    let arrowPrev = splideContainer.querySelector(".mm-arrow-left");

    function updateCrossSellArrows() {
      const atStart = splide.index <= 0;
      const atEnd = splide.index >= splide.Components.Controller.getEnd();

      arrowPrev.classList.toggle("mm-disabled", atStart);
      arrowNext.classList.toggle("mm-disabled", atEnd);
    }

    arrowNext.addEventListener("click", function () {
      splide.go("+1");
    });
    arrowPrev.addEventListener("click", function () {
      splide.go("-1");
    });

    splide.on("mounted move", updateCrossSellArrows);
    updateCrossSellArrows();
  }
}

function mmInitSplideTestimonials() {
  const id = ".mm-dc-testimonials";
  const splideElem = document.querySelector(id);

  if (splideElem) {
    new Splide(splideElem, {
      type: "loop",
      arrows: false,
      pagination: true,
      gap: 20,
      autoplay: true,
      interval: 2000,
      perPage: 1,
      padding: {
        right: "0",
        left: "0",
      },
    }).mount();
  }
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    // mmInitSplide();
    mmInitSplideMobile();
    mmInitSplideTestimonials();
    //mmOpenCart();
    // mmGetFreeProductsVariantId();
  },
  { once: true },
);

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function debounce(func, duration) {
  let timeout;
  return function (...args) {
    const effect = () => {
      timeout = null;
      return func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(effect, duration);
  };
}

function mmCartSectionElement() {
  return document.getElementById("shopify-section-mm-cart");
}

function mmCartProductsContainerElement() {
  return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(productVariantId) {
  return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
  const itemEl = mmCartItem(productVariantId);

  return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(productVariantId) {
  const quantityEl = mmCartItemQuantityEl(productVariantId);

  return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
  // Display qtty in front
  if (newQuantity >= 0) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);

    quantityEl.dataset.itemQuantity = newQuantity;
    quantityEl.innerText = newQuantity;
  }
}

function mmCartHTMLFromData(data) {
  const el = document.createElement("DIV");
  el.innerHTML = data.sections["mm-cart"];

  return el;
}

function extractItemsFromCartHTML(data) {
  const el = mmCartHTMLFromData(data);
  return el.querySelector(".mm-dc-products-container");
}

function insertCartProductsFromResponse(data) {
  const itemsContainer = extractItemsFromCartHTML(data);
  mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

  return data;
}

function extractTotalPriceFromCartHTML(data) {
  const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
  return cartEl.querySelector("[data-cart-total-price]");
}

function insertInsertTotalPriceFromResponse(data) {
  const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
  const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
  if (newTotalPriceEl && currentTotalPriceEl) {
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
  }
  return data;
}

function mmAPIRequest(method, path, body) {
  document.querySelector(".mm-dc-products")?.classList?.add("mm-inactive");
  return fetch(window.Shopify.routes.root + path, {
    method: method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => {
      document.querySelector(".mm-dc-products")?.classList?.remove("mm-inactive");
      updateCartCount(data.item_count != null ? data.item_count : 0);
      if (data.status && data.status > 400) {
        throw data;
      } else {
        return data;
      }
    });
}

// récupérer le panier
function mmGetCart() {
  return mmAPIRequest("GET", "cart.js");
}

// Ouvrir le panier
function mmOpenCart() {
  mmGetCart();
  document.querySelector(".mm-drawer-cart-filter").classList.add("mm-dc-is-open");
  document.querySelector("html").classList.add("stop-scrolling");
}

// Ouvrir et refresh le panier (utilisé pour faire fonctionner les babybox et superbox avec le panier)
function mmOpenAndRefreshCart() {
  function handleResponse() {
    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = this.responseText;
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
    innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
    // mmInitSplide();
    mmInitSplideMobile();
    mmInitSplideTestimonials();
    if (typeof window.initDeliveryEstimates === "function") {
      window.initDeliveryEstimates(document.querySelector(".mm-drawer-cart-filter"));
    }
    document.querySelector(".mm-drawer-cart-filter").classList.add("mm-dc-is-open");
    document.querySelector("html").classList.add("stop-scrolling");
  }
  // Construction de l'URL en fonction de la langue
  const rootUrl = document.querySelector(".mm-drawer-cart-filter").dataset.localization;

  let url;
  if (rootUrl == "/") {
    url = `/?section_id=mm-cart`;
  } else {
    url = `${rootUrl}/?section_id=mm-cart`;
  }

  const request = new XMLHttpRequest();
  request.addEventListener("load", handleResponse);
  request.open("GET", url, true);
  request.send();
}

// Fermer le panier
function mmCloseCart() {
  document.querySelector(".mm-drawer-cart-filter").classList.remove("mm-dc-is-open");
  document.querySelector("html").classList.remove("stop-scrolling");
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
  const newCartEl = document.createElement("DIV");
  newCartEl.innerHTML = data.sections["mm-cart"];
  const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
  innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
  // mmInitSplide();
  mmInitSplideMobile();
  mmInitSplideTestimonials();

  if (typeof window.initDeliveryEstimates === "function") {
    window.initDeliveryEstimates(document.querySelector(".mm-drawer-cart-filter"));
  }

  // Yotpo n'est pas chargé si les cookies sont refusés : tout accès doit passer par window
  window.yotpoWidgetsContainer?.initWidgets();

  setTimeout(() => {
    document.querySelector("yotpo-global-template")?.setCartProductCardReviewsCount?.();
  }, 350);

  return data;
}

// Ajouter un item au panier
function mmAddProductToCart(productId, { quantity = 1, openCart = true }, selling_plan_id = "", buttonElement = null) {
  if (buttonElement && buttonElement.dataset.available && buttonElement.dataset.available == "false") {
    return;
  }
  if (typeof window.__mmKlaviyoSetAddToCartIntent === "function") {
    window.__mmKlaviyoSetAddToCartIntent();
  }
  const item = {
    quantity: quantity,
    id: productId,
  };
  if (selling_plan_id) {
    item.selling_plan = selling_plan_id;
  }

  // Add unlocked upsell reward products (if configured) alongside main item
  const selectedMethod = document.querySelector('input[name="purchase_option"]:checked')?.value || "one_time";
  const rewardVariantIds = new Set();
  document.querySelectorAll("[data-mm-subscription-upsell] [data-mm-upsell-tier].is-unlocked[data-mm-reward-variant-id]").forEach((el) => {
    const scope = (el.getAttribute("data-mm-reward-scope") || "both").toLowerCase();
    const allowed = scope === "both" || scope === selectedMethod;
    if (!allowed) return;
    const id = el.getAttribute("data-mm-reward-variant-id");
    if (id) rewardVariantIds.add(String(id));
  });

  const rewardItemsFromCart = (cart) => {
    const inCart = new Set((cart.items || []).map((line) => String(line.variant_id)));
    return Array.from(rewardVariantIds)
      .filter((id) => !inCart.has(id))
      .map((id) => ({
        id,
        quantity: 1,
        properties: {
          _free_sub_product: "true",
        },
      }));
  };

  const postAddToCart = (rewardItems) =>
    mmAPIRequest("POST", "cart/add.js", {
      items: [item, ...rewardItems],
      sections: "mm-cart",
    })
      .then(mmAddOrRemoveFreeProducts)
      .then(refreshCartFromData)
      .then(() => {
        if (openCart) {
          setTimeout(mmOpenCart);
        }
      });

  const onAddError = (error) => {
    if (typeof window.__mmKlaviyoClearAddToCartIntent === "function") {
      window.__mmKlaviyoClearAddToCartIntent();
    }
    mmCartProductsContainerElement().innerHTML = `
            Oups, il y a eu une erreur, essayez de recharger la page !
        `;
    mmOpenCart();
    console.log(error);
  };

  mmGetCart()
    .catch(() => null)
    .then((cart) => {
      const rewards =
        cart && Array.isArray(cart.items) ? rewardItemsFromCart(cart) : [];
      return postAddToCart(rewards);
    })
    .catch(onAddError);
}

function mmIncreaseProductQuantity(element) {
  const lineIndex = parseInt(element.dataset.itemLine);
  const quantityEl = element.parentNode.querySelector("[data-item-quantity]");
  const currentQuantity = parseInt(quantityEl.dataset.itemQuantity);
  const newQuantity = currentQuantity + 1;

  // Update UI optimistically
  quantityEl.dataset.itemQuantity = newQuantity;
  quantityEl.innerText = newQuantity;

  mmDebouncedPushNewQuantityByLine(lineIndex, newQuantity);
}

function mmDecreaseProductQuantity(element) {
  const lineIndex = parseInt(element.dataset.itemLine);
  const quantityEl = element.parentNode.querySelector("[data-item-quantity]");
  const currentQuantity = parseInt(quantityEl.dataset.itemQuantity);
  const newQuantity = Math.max(0, currentQuantity - 1);

  // Update UI optimistically
  quantityEl.dataset.itemQuantity = newQuantity;
  quantityEl.innerText = newQuantity;

  mmDebouncedPushNewQuantityByLine(lineIndex, newQuantity);
}

function mmDestroyProductFromCart(element) {
  // Get the line index from the clicked element
  const lineIndex = parseInt(element.dataset.itemLine);

  // Use line index for unique identification of cart item
  mmAPIRequest("POST", "cart/change.js", {
    line: lineIndex,
    quantity: 0,
    sections: "mm-cart",
  })
    .then(mmAddOrRemoveFreeProducts)
    .then(refreshCartFromData);
}

function mmDestroyProductByVariantId(productVariantId) {
  // Legacy function for removing all products with a specific variant_id
  // Used for free product swapping where we want to remove all instances
  mmAPIRequest("POST", "cart/change.js", {
    id: productVariantId.toString(),
    quantity: 0,
    sections: "mm-cart",
  })
    .then(mmAddOrRemoveFreeProducts)
    .then(refreshCartFromData);
}

function mmPushNewQuantity(productVariantId) {
  const quantity = mmGetCartItemQuantity(productVariantId);

  mmAPIRequest("POST", "cart/change.js", {
    id: productVariantId.toString(),
    quantity: quantity,
    sections: "mm-cart",
  })
    .then(mmAddOrRemoveFreeProducts)
    .then(refreshCartFromData);
}

function mmChangeFreeProductInCart(productVariantIdToAdd, productVariantIdToRemove, clickedElem) {
  // Debounce sur le CTA
  clickedElem.innerText = "AJOUTÉ !";
  clickedElem.classList.add("mm-disabled");
  if (typeof window.__mmKlaviyoSetAddToCartIntent === "function") {
    window.__mmKlaviyoSetAddToCartIntent();
  }

  mmAPIRequest("POST", "cart/add.js", {
    items: [{ quantity: 1, id: productVariantIdToAdd }],
    sections: "mm-cart",
  }).then(() => mmDestroyProductByVariantId(productVariantIdToRemove));
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
  mmPushNewQuantity(productVariantId);
}, 300);

function mmPushNewQuantityByLine(lineIndex, quantity) {
  mmAPIRequest("POST", "cart/change.js", {
    line: lineIndex,
    quantity: quantity,
    sections: "mm-cart",
  })
    .then(mmAddOrRemoveFreeProducts)
    .then(refreshCartFromData);
}

const mmDebouncedPushNewQuantityByLine = debounce(function (lineIndex, quantity) {
  mmPushNewQuantityByLine(lineIndex, quantity);
}, 300);

/**
 * Sync progress-bar free products vs cart using the **section HTML from the API response**,
 * not the live DOM (which can still show the previous cart before refreshCartFromData runs).
 */
function mmAddOrRemoveFreeProducts(data) {
  if (!data || !data.sections || !data.sections["mm-cart"]) {
    return Promise.resolve(data);
  }

  const el = mmCartHTMLFromData(data);
  const productsContainerFromResponse = el.querySelector(".mm-dc-products-container");
  const freeProductEls = el.querySelector("[data-free-products]");

  if (!freeProductEls || !productsContainerFromResponse) {
    return Promise.resolve(data);
  }

  /** Lignes « offert » palier uniquement : même variant que l’abonnement payant possible. */
  const toAddVariants = {};
  const linesToRemove = [];

  Array.from(freeProductEls.children).forEach((freeProductEl) => {
    const productId = freeProductEl.dataset.variantId;
    if (!productId) return;

    const isFree = freeProductEl.dataset.freeProduct === "true";
    const freeRow = productsContainerFromResponse.querySelector(
      `.mm-dc-free-product[data-cart-item-id="${productId}"]`,
    );

    if (freeRow && isFree) {
      // déjà affiché comme ligne offerte et seuil OK
    } else if (freeRow && !isFree) {
      const line = parseInt(freeRow.dataset.itemLine, 10);
      if (!Number.isNaN(line)) {
        linesToRemove.push(line);
      }
    } else if (!freeRow && isFree) {
      toAddVariants[productId] = 1;
    }
  });

  if (linesToRemove.length === 0 && Object.keys(toAddVariants).length === 0) {
    return Promise.resolve(data);
  }

  const uniqueLinesToRemove = [...new Set(linesToRemove)].sort((a, b) => b - a);

  let chain = Promise.resolve(data);
  for (const line of uniqueLinesToRemove) {
    chain = chain.then(() =>
      mmAPIRequest("POST", "cart/change.js", {
        line,
        quantity: 0,
        sections: "mm-cart",
      }),
    );
  }
  return chain.then((lastData) => {
    if (Object.keys(toAddVariants).length > 0) {
      return mmAPIRequest("POST", "cart/update.js", { updates: toAddVariants, sections: "mm-cart" });
    }
    return lastData;
  });
}

function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
  // Debounce sur le CTA
  clickedElem.innerText = "AJOUTÉ !";
  clickedElem.classList.add("mm-disabled");

  // Ajouter le free product
  mmAddProductToCart(productId, { openCart: false });
}

//Show selling plan
function toggleSellingPlan(checkbox) {
  const productCard = checkbox.closest(".mm-dc-product-container");
  const subContainer = checkbox.closest(".mm-dc-cart-item-subscribe-container");
  const subSelectContainer = subContainer.querySelector(".mm-dc-select-selling-plan-container");
  const line = parseInt(subContainer.dataset.itemLine);

  if (checkbox.checked) {
    const selling_plan = subSelectContainer.querySelector("select").value;
    subSelectContainer.classList.remove("hidden");
    updateSellingPlan(line, productCard, selling_plan);
  } else {
    subSelectContainer.classList.add("hidden");
    updateSellingPlan(line, productCard, null);
  }
}

//Change Selling Plan
function updateSellingPlan(line, productCard, sellingPlan) {
  const quantity = parseInt(productCard.querySelector("[data-item-quantity]").innerText);

  // Objet attendu par Shopify
  let payload = {
    line: line, // Ligne dans le panier
    quantity: quantity, // Quantité de la ligne
    selling_plan: sellingPlan, // Null ou ID du plan
    sections: "mm-cart", // Demande à Shopify de renvoyer le HTML de la section dans la réponse pour `refreshCartFromData`
  };

  mmAPIRequest("POST", "cart/change.js", payload)
    .then(refreshCartFromData)
    .catch((error) => {
      mmCartProductsContainerElement().innerHTML = `
          Oups, il y a eu une erreur, essayez de recharger la page !
      `;
      console.log("Erreur API Shopify:", error);
    });
}

window.addEventListener("DOMContentLoaded", (event) => {
  mmGetCart();
});

function updateCartCount(value) {
  const cartCounterElement = document.querySelector(".mm-header-cart-container .cart-counter");
  const cartCountBubble = document.querySelector(".mm-cart-count-bubble");

  if (cartCounterElement) {
    cartCounterElement.innerText = value;
    cartCounterElement.style.display = value === 0 ? "none" : "inline-block";
  }

  if (cartCountBubble) {
    cartCountBubble.style.display = value === 0 ? "none" : "flex";
  }
}

// --- Code promo (MM Cart) ---
function mmPromoExistingCodes(root) {
  return Array.from(root.querySelectorAll('[data-ref="discount-badge"]'))
    .map((badge) => badge.dataset.discountCode)
    .filter(Boolean);
}

function mmPromoSetError(root, message) {
  const errorEl = root.querySelector('[data-ref="discount-error"]');
  const field = root.querySelector(".mm-dc-promo-code__field");
  if (!errorEl) return;

  if (!message) {
    errorEl.hidden = true;
    errorEl.textContent = "";
    field?.classList.remove("is-error");
    return;
  }

  errorEl.hidden = false;
  errorEl.textContent = message;
  field?.classList.add("is-error");
  setTimeout(() => mmPromoSetError(root, ""), 2500);
}

function mmPromoSetLoading(root, isLoading) {
  const button = root.querySelector('[data-ref="apply-discount"]');
  if (!button) return;
  button.disabled = isLoading;
  button.classList.toggle("is-loading", isLoading);
}

function mmPromoApplyCode(root) {
  const input = root.querySelector('[data-ref="discount-input"]');
  const code = (input?.value || "").trim();

  if (!code) {
    mmPromoSetError(root, root.dataset.pleaseInsertACode);
    return;
  }

  const existing = mmPromoExistingCodes(root);
  if (existing.some((c) => c.toLowerCase() === code.toLowerCase())) {
    mmPromoSetError(root, root.dataset.codeAlreadyApplied);
    return;
  }

  mmPromoSetLoading(root, true);
  mmPromoSetError(root, "");

  mmAPIRequest("POST", "cart/update.js", {
    discount: [...existing, code].join(","),
    sections: "mm-cart",
  })
    .then((data) => {
      const failed = data.discount_codes?.find(
        (d) => d.code?.toLowerCase() === code.toLowerCase() && d.applicable === false,
      );
      if (failed) {
        mmPromoSetLoading(root, false);
        mmPromoSetError(root, root.dataset.codeNotApplicable);
        if (input) input.value = "";
        return null;
      }
      return refreshCartFromData(data);
    })
    .catch((error) => {
      console.error(error);
      mmPromoSetLoading(root, false);
      mmPromoSetError(root, root.dataset.errorApplyDiscount);
    });
}

function mmPromoRemoveCode(root, discountCode) {
  const existing = mmPromoExistingCodes(root);
  const next = existing.filter((c) => c !== discountCode);

  mmPromoSetLoading(root, true);
  mmAPIRequest("POST", "cart/update.js", {
    discount: next.join(","),
    sections: "mm-cart",
  })
    .then(refreshCartFromData)
    .catch((error) => {
      console.error(error);
      mmPromoSetLoading(root, false);
      mmPromoSetError(root, root.dataset.errorRemoveDiscount);
    });
}

document.addEventListener("click", (event) => {
  const applyBtn = event.target.closest('[data-ref="apply-discount"]');
  if (applyBtn) {
    const root = applyBtn.closest(".mm-dc-promo-code");
    if (root) {
      event.preventDefault();
      mmPromoApplyCode(root);
    }
    return;
  }

  const removeBtn = event.target.closest('[data-ref="remove-discount"]');
  if (removeBtn) {
    const root = removeBtn.closest(".mm-dc-promo-code");
    const badge = removeBtn.closest('[data-ref="discount-badge"]');
    if (root && badge?.dataset.discountCode) {
      event.preventDefault();
      event.stopPropagation();
      mmPromoRemoveCode(root, badge.dataset.discountCode);
    }
    return;
  }

  // Badge dans le summary : ne pas ouvrir/fermer l'accordéon
  if (event.target.closest('[data-ref="discount-badge"]')) {
    event.preventDefault();
    event.stopPropagation();
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Enter") return;
  const input = event.target.closest('[data-ref="discount-input"]');
  if (!input) return;
  const root = input.closest(".mm-dc-promo-code");
  if (!root) return;
  event.preventDefault();
  mmPromoApplyCode(root);
});
